<template>
  <div class="boxsizing materialshowbox">
    <ul v-if="!disabled">
      <draggable v-model="newContent">
        <transition-group>
          <li v-for="(item, index) in value" :key="Number(index)"><span class="grayae">{{getCnName(item.type) || '微信图文'}}:</span><p class="ellipsis grayae">{{item.remark || item.title || (item['content'] && item['content'].title) || (item['content'] && item['content'][0] && item['content'][0].title) || (item[0] && item[0]['content'] && item[0]['content']['news_item'] && item[0]['content']['news_item'][0].title) || (item[0] && item[0].title) || '临时素材'}}</p><a href="javascript:;" @click="deleteHandle(index)" class="color-red">删除</a></li>
        </transition-group>
      </draggable>
    </ul>
    <ul v-else>
      <li v-for="(item, index) in value" :key="Number(index)"><span class="grayae">{{getCnName(item.type) || '微信图文'}}:</span><p class="ellipsis grayae">{{item.remark || item.title || (item['content'] && item['content'].title) || (item['content'] && item['content'][0] && item['content'][0].title) || (item[0] && item[0]['content'] && item[0]['content']['news_item'] && item[0]['content']['news_item'][0].title) || (item[0] && item[0].title) || '临时素材'}}</p></li>
    </ul>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
export default {
  name: 'MaterialShow',
  props: [
    'value',
    'disabled'
  ],
  data () {
    return {
      newContent: this.value
    }
  },
  components: {
    draggable
  },
  watch: {
    'value': function (val) {
      this.newContent = this.value
      // console.log('newContent', val)
      this.checkVal()
    },
    'newContent': function (val) {
      this.$emit('input', val)
    }
  },
  methods: {
    checkVal () { // 检查是否有失效的素材，有的话删除并提醒用户重新保存
      for (var key in this.value) {
        var openTips = false
        if (this.value[key].invalid) {
          openTips = true
          this.newContent = this.value.splice(key, 1)
        }
        openTips && this.tipsOpen()
      }
    },
    tipsOpen () {
      this.$alert('有素材已失效，请重新保存以更新信息', '提示', {
        confirmButtonText: '确定',
        callback: action => {
          // this.$message({
          //   type: 'info',
          //   message: `action: ${ action }`
          // });
        }
      })
    },
    async deleteHandle (index) {
      this.value.splice(index, 1)
    },
    getCnName (type) {
      switch (type) {
        case 'mpnews':
          return '微信图文'
        case 'news':
          return '本地图文'
        case 'article':
          return '已发布文章'
        case 'local_text':
          return '本地文本'
        case 'voice':
          return '微信语音'
        case 'video':
          return '本地视频'
        case 'music':
          return '本地音乐'
        case 'image':
          return '微信图片'
        case 'local_miniprogrampage':
          return '本地小程序'
        case 'miniprogrampage':
          return '临时小程序'
        case 'text':
          return '临时文本'
        default:
          return '未知素材'
      }
    }
  },
  created () {
  },
  mounted () {
    // console.log('mounted', this.value)
    this.newContent = this.value
    this.checkVal()
  }
}
</script>
<style scoped>
.materialshowbox {
  background: #eee;
  border-radius: 5px;
  padding: 20px 40px;
}
.materialshowbox ul li {
  width: 100%;
  height: 40px;
  line-height: 40px;
  position: relative;
  overflow: hidden;
}
.materialshowbox ul li span {
  float: left;
}
.materialshowbox ul li a {
  float: right;
}
.materialshowbox ul li p {
  position: absolute;
  left: 80px;
  top: 0;
  right: 80px;
  height: 40px;
  line-height: 40px;
  display: block;
  overflow: hidden;
}
</style>
